import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import parametrageEdition from '@/store/modules/parametrageEdition';
import menu from '@/store/modules/menu/menu';
import user from './modules/user';
import parametres from './modules/parametres';
import societe from './modules/societe';
import permissions from './modules/permissions';
import tableUserParam from './modules/tableUserParam';
import categorieVente from './modules/categorieVente';

import * as types from './mutation-type';

Vue.use(Vuex);

function dateTimeReviver(key, value) {
  let resultRegex;
  if (typeof value === 'string') {
    resultRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/.exec(value);
    if (resultRegex) {
      return new Date(value);
    }
  }
  return value;
}

const modules = {
  parametrageEdition,
  user,
  parametres,
  permissions,
  societe,
  menu,
  tableUserParam,
  categorieVente,
};

const store = new Vuex.Store({
  modules: modules,
  plugins: [createPersistedState({
    getState(key, storage) {
      try {
        const localValue = storage.getItem(key);
        let state;
        if (localValue !== 'undefined') {
          state = JSON.parse(localValue, dateTimeReviver);
        }
        return state;
      } catch (err) {
        /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      }

      return undefined;
    },
    paths: ['parametrageEdition', 'user', 'parametres', 'permissions', 'societe', 'menu', 'tableUserParam', 'categorieVente'],
  })],
});

export default store;

export function resetState() {
  // eslint-disable-next-line
  Object.keys(store._modules.root._children).forEach((module) => {
    store.commit(module + '/' + types.RESET_STATE);
  });
}
